'use strict';

const Mediator = require('./../../../core/mediator');
const container = require('./../../../core/container');
const userRepo = require('./../repository/UserRepository');
const aclRepo = require('./../repository/AclRepository');

module.exports.init = function() {
    userRepo.getCurrentUser().done(function(user) {
        aclRepo.getPermissions(user.id).done(function(data) {
            container.set('permissions', data);
            container.set('current_user', user);
            container.set('current_user_is_super_admin', user.group_types && user.group_types.includes('super_admin'));
            Mediator.publish('application:ready');
        });
    });

    container.set('isAllowedTo', function(action) {
        const permissions = container.get('permissions') || [];

        return permissions.indexOf(action) !== -1;
    });
};
